import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=afdb5e3c&scoped=true&"
import script from "./Paper.vue?vue&type=script&lang=js&"
export * from "./Paper.vue?vue&type=script&lang=js&"
import style0 from "./Paper.vue?vue&type=style&index=0&id=afdb5e3c&prod&lang=scss&scoped=true&"
import style1 from "./Paper.vue?vue&type=style&index=1&id=afdb5e3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdb5e3c",
  null
  
)

export default component.exports